import { render, staticRenderFns } from "./AliveVideos.vue?vue&type=template&id=343c87aa&"
import script from "./AliveVideos.vue?vue&type=script&lang=js&"
export * from "./AliveVideos.vue?vue&type=script&lang=js&"
import style0 from "./AliveVideos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports